import { useState, useEffect } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { isSoundMuted, toggleSoundMuted } from '@/utils/sounds';

/**
 * Global Sound Toggle Button
 * Persists mute state to localStorage
 */
function SoundToggle({ className = "" }) {
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    // Initialize from localStorage
    setMuted(isSoundMuted());
  }, []);

  const handleToggle = () => {
    const newMuted = toggleSoundMuted();
    setMuted(newMuted);
  };

  return (
    <button
      onClick={handleToggle}
      className={`p-2 rounded-lg transition-all ${
        muted 
          ? 'bg-gray-200 text-gray-500 hover:bg-gray-300' 
          : 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
      } ${className}`}
      title={muted ? 'Sound effects are off. Click to enable.' : 'Sound effects are on. Click to mute.'}
      aria-label={muted ? 'Enable sound effects' : 'Mute sound effects'}
      data-testid="sound-toggle-btn"
    >
      {muted ? (
        <VolumeX className="w-5 h-5" />
      ) : (
        <Volume2 className="w-5 h-5" />
      )}
    </button>
  );
}

export default SoundToggle;
